import md5 from "js-md5";
import { getRandom } from "@/common/utils";
import { Base64 } from "js-base64";
import { getToken } from "@/common/cookies";
import axios from "axios";

const SECRET_KEY1 = "HUJOSUE1OFDJKSAOP3KJLN_FDKJSAP$JFDAP*JFKDASP()JFDKMFMFM";

export default defineNuxtPlugin((nuxtApp) => {
  const { $cookies } = useNuxtApp();

  // 创建 axios 实例
  const $axios = axios.create({
    timeout: 1000 * 120,
    baseURL: __BASE_URL__ || "http://192.168.0.104:8087/",
  });

  // 请求拦截器
  $axios.interceptors.request.use((config) => {
    const timestamp = parseInt(new Date().valueOf()) / 1000;
    const radom_res = getRandom(0, 100);
    const nonce = String(radom_res) + String(timestamp);
    const md5_str = SECRET_KEY1 + String(timestamp) + nonce;
    const md5_val = md5(md5_str);
    const auth_str = md5_val + "|" + timestamp + "|" + nonce;
    const base_encond = Base64.encode(auth_str);

    const token = $cookies.get("sharkfoto_token") || "";

    // FormData 必须由运行时自动带 multipart boundary；强制 application/json 会导致文件被序列化成 {}
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    } else if (config.headers["Content-Type"] == null) {
      config.headers["Content-Type"] = "application/json";
    }
    config.headers["Access-Control-Allow-Headers"] =
      "authapi,token,content-type";
    config.headers.authapi = base_encond;
    if (token) {
      config.headers.token = token;
    }
    return config;
  });

  // 响应拦截器
  $axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      console.log("error", error);
      const code = parseInt(error.response && error.response.status);
      if (code === 400) {
        // 使用 Nuxt 4 的导航 API
        navigateTo("/400");
      } else {
        console.log("有错误：：", code);
      }
      return Promise.reject(error);
    }
  );

  // 提供 $axios 给应用
  nuxtApp.provide("axios", $axios);
  nuxtApp.provide("$axios", $axios);
});
